'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _package = require('../../../package.json');

var _containers = require('../containers');

var _components = require('../components');

var _events = require('../events');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var preLoadingStates = [_constants.QD_STATUS_INACTIVE, _constants.QD_STATUS_INITIALIZING, _constants.QD_STATUS_FAILED];
var displayFormStates = [_constants.QD_STATUS_ACTIVE, _constants.QD_STATUS_PMT_FAILED, _constants.QD_STATUS_CLOSING];

var QuickDepositComponent = function (_React$Component) {
  (0, _inherits3.default)(QuickDepositComponent, _React$Component);

  function QuickDepositComponent() {
    (0, _classCallCheck3.default)(this, QuickDepositComponent);
    return (0, _possibleConstructorReturn3.default)(this, (QuickDepositComponent.__proto__ || (0, _getPrototypeOf2.default)(QuickDepositComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickDepositComponent, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      var isPaymentsApiAvailable = typeof window.PaymentAPI === 'function';
      this.setState({ paymentsAPIAvailable: isPaymentsApiAvailable });

      require('./quick-deposit.scss');
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          _props$openReceived = _props.openReceived,
          openReceived = _props$openReceived === undefined ? function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return data;
      } : _props$openReceived,
          _props$configReceived = _props.configReceived,
          configReceived = _props$configReceived === undefined ? function () {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return config;
      } : _props$configReceived,
          _props$config = _props.config,
          config = _props$config === undefined ? {} : _props$config,
          _props$messageBus = _props.messageBus,
          messageBus = _props$messageBus === undefined ? {
        subscribe: function subscribe() {}
      } : _props$messageBus;

      configReceived(config);
      this.qdOpenSubscriptionToken = messageBus.subscribe(_events.MESSAGE_SUB_QD_OPEN, function (topic, data) {
        openReceived(data);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props$messageBus$uns = this.props.messageBus.unsubscribe,
          unsubscribe = _props$messageBus$uns === undefined ? function (msg) {
        return { msg: msg };
      } : _props$messageBus$uns;

      unsubscribe(this.qdOpenSubscriptionToken);
    }
  }, {
    key: 'onAnimationEnd',
    value: function onAnimationEnd() {
      if (this.props.status === _constants.QD_STATUS_CLOSING) {
        this.props.closeComponent();
      }
    }
  }, {
    key: 'showOtherMethods',
    value: function showOtherMethods() {
      var _props2 = this.props,
          status = _props2.status,
          activeDeposit = _props2.activeDeposit,
          isLoading = _props2.isLoading,
          initData = _props2.initData;

      var hasActiveDeposit = (activeDeposit || {}).amount;
      return status === _constants.QD_STATUS_CLOSING || initData.showOtherDepositMethodsLink && !isLoading && !hasActiveDeposit && !(preLoadingStates.indexOf(status) >= 0);
    }
  }, {
    key: 'showDepositAgain',
    value: function showDepositAgain() {
      var _props3 = this.props,
          status = _props3.status,
          activeDeposit = _props3.activeDeposit,
          isLoading = _props3.isLoading;

      var hasActiveDeposit = (activeDeposit || {}).amount;
      var isIn3DSJourney = [_constants.QD_STATUS_3DS, _constants.QD_STATUS_3DS_V2].includes(status);

      return !isLoading && hasActiveDeposit && !isIn3DSJourney && !preLoadingStates.indexOf(status) >= 0;
    }
  }, {
    key: 'getFormContainer',
    value: function getFormContainer() {
      var _props4 = this.props,
          status = _props4.status,
          initData = _props4.initData,
          countryCode = _props4.countryCode;

      var showErrorMessage = status === _constants.QD_STATUS_PMT_FAILED;
      var showSuccessMessage = status === _constants.QD_STATUS_PMT_SUCCEDED;
      var showDepositTracker = !initData.forceHideDLT && (!initData.hideDLTforCountryCodes || initData.hideDLTforCountryCodes && !initData.hideDLTforCountryCodes.includes(countryCode));

      return !showErrorMessage && !showSuccessMessage && displayFormStates.indexOf(this.props.status) >= 0 && _react2.default.createElement(_containers.FormContainer, { showOtherMethods: !!this.showOtherMethods, showDepositTracker: showDepositTracker });
    }
  }, {
    key: 'getLoadingSpinner',
    value: function getLoadingSpinner() {
      var _props5 = this.props,
          countryCode = _props5.countryCode,
          status = _props5.status,
          isLoading = _props5.isLoading,
          t = _props5.t;

      var loadingSpinnerTitle = t(_constants.TRANSLATION_CONTEXT)('LOADING_SPINNER_TITLE');
      var loadingSpinnerMessage = t(_constants.TRANSLATION_CONTEXT)('LOADING_SPINNER_TEXT');
      var showSpinner = (isLoading || !this.state.paymentsAPIAvailable || [_constants.QD_STATUS_PMT_SUBMITTING, _constants.QD_STATUS_3DS_V2].includes(status)) && !(preLoadingStates.indexOf(status) >= 0);

      return showSpinner && _react2.default.createElement(_components.LoadingSpinner, {
        loadingSpinnerTitle: loadingSpinnerTitle,
        loadingSpinnerMessage: loadingSpinnerMessage,
        countryCode: countryCode
      });
    }
  }, {
    key: 'getErrorMessage',
    value: function getErrorMessage() {
      var chatUrl = this.props.config.chatUrl;
      var errorMessage = this.props.errorMessage;

      var showErrorMessage = this.props.status === _constants.QD_STATUS_PMT_FAILED;
      return showErrorMessage && _react2.default.createElement(_containers.ErrorMessageContainer, {
        chatUrl: chatUrl,
        showOtherMethods: !!this.showOtherMethods,
        showDepositAgain: !!this.showDepositAgain,
        errorMessage: errorMessage
      });
    }
  }, {
    key: 'getSuccessMessage',
    value: function getSuccessMessage() {
      var showSuccessMessage = this.props.status === _constants.QD_STATUS_PMT_SUCCEDED;
      return showSuccessMessage && _react2.default.createElement(_containers.AnimatedSuccessMessageContainer, { showDepositAgain: !!this.showDepositAgain });
    }
  }, {
    key: 'getHeader',
    value: function getHeader() {
      var _props6 = this.props,
          status = _props6.status,
          initData = _props6.initData,
          config = _props6.config;
      var _config$layout = config.layout,
          layout = _config$layout === undefined ? _constants.QD_DEFAULT_LAYOUT : _config$layout;

      var showCloseButton = initData.showCloseButton && layout === _constants.QD_DEFAULT_LAYOUT;
      return status !== _constants.QD_STATUS_CLOSED && !(preLoadingStates.indexOf(status) >= 0) && _react2.default.createElement(_containers.HeaderContainer, { showCloseButton: showCloseButton });
    }
  }, {
    key: 'getBackButton',
    value: function getBackButton() {
      var _props7 = this.props,
          status = _props7.status,
          initData = _props7.initData,
          config = _props7.config,
          closingComponent = _props7.closingComponent,
          t = _props7.t;
      var _config$layout2 = config.layout,
          layout = _config$layout2 === undefined ? _constants.QD_DEFAULT_LAYOUT : _config$layout2;

      var showCloseButton = initData.showCloseButton && layout !== _constants.QD_DEFAULT_LAYOUT;
      var closeButtonLabel = t(_constants.TRANSLATION_CONTEXT)('PMT_BACK');
      return showCloseButton && status !== _constants.QD_STATUS_CLOSED && !(preLoadingStates.indexOf(status) >= 0) && _react2.default.createElement(_components.CloseButton, { text: closeButtonLabel, onClick: function onClick() {
          return closingComponent();
        } });
    }
  }, {
    key: 'getSecurePaymentPanel',
    value: function getSecurePaymentPanel() {
      return this.props.status === _constants.QD_STATUS_3DS && _react2.default.createElement(_containers.SecurePaymentPanel, null);
    }
  }, {
    key: 'getStatusClass',
    value: function getStatusClass() {
      var status = this.props.status;


      var isOpened = displayFormStates.indexOf(status) >= 0 || [_constants.QD_STATUS_PMT_SUBMITTING, _constants.QD_STATUS_PMT_SUCCEDED, _constants.QD_STATUS_3DS, _constants.QD_STATUS_3DS_V2].includes(status);

      var statusClass = 'hidden';
      if (status === _constants.QD_STATUS_CLOSING) {
        statusClass = 'closed';
      } else if (isOpened) {
        statusClass = 'opened';
      }
      return statusClass;
    }
  }, {
    key: 'getLayoutClass',
    value: function getLayoutClass() {
      return 'qd-' + ((this.props.config || {}).layout || _constants.QD_DEFAULT_LAYOUT);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var statusClass = this.getStatusClass(this.props.status);
      return _react2.default.createElement(
        'div',
        { className: 'qd-wrapper ' + statusClass },
        this.props.config.showOverlay && _react2.default.createElement(_components.Overlay, { className: this.props.config.overlayClassName, statusClassName: statusClass }),
        _react2.default.createElement(
          'div',
          { className: 'qd ' + statusClass + ' ' + this.getLayoutClass(), onAnimationEnd: function onAnimationEnd() {
              return _this2.onAnimationEnd();
            } },
          this.getHeader(),
          this.state.paymentsAPIAvailable && this.getFormContainer(),
          this.state.paymentsAPIAvailable && this.getErrorMessage(),
          this.state.paymentsAPIAvailable && this.getSuccessMessage(),
          this.getLoadingSpinner(),
          this.state.paymentsAPIAvailable && this.getSecurePaymentPanel(),
          this.getBackButton(),
          _react2.default.createElement(
            'div',
            { className: 'hidden version' },
            _package.version
          )
        )
      );
    }
  }]);
  return QuickDepositComponent;
}(_react2.default.Component);

exports.default = QuickDepositComponent;